import { CommonModule, DOCUMENT } from '@angular/common';
import {
  AfterViewInit, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA,
  ElementRef, Inject, OnInit, ViewChild
} from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FeatherIconDirective } from '../../../core/feather-icon/feather-icon.directive';
import { AppService } from '../../../app.service';
import { NavigationService } from '../../shared/navigation/navigation.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    NgScrollbar,
    CommonModule,
    RouterModule,
    FeatherIconDirective,
    MatTooltipModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @ViewChild('sidebarToggler') sidebarToggler: ElementRef;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public router: Router,
    public mainservice: AppService,
    public menuService: NavigationService,
    public commonService: AppService,
    private cdr: ChangeDetectorRef
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // ALWAYS remove open-sidebar-folded on navigation so it never sticks
        this.document.body.classList.remove('open-sidebar-folded');
        
        if (window.matchMedia('(max-width: 991px)').matches) {
          this.document.body.classList.remove('sidebar-open');
        } else {
          // AUTO-SHRINK: ONLY for the detailed extraction workspace
          if (event.urlAfterRedirects.includes('/smartdocs/extract/')) {
            this.document.body.classList.add('sidebar-folded');
            if (this.sidebarToggler) {
              this.sidebarToggler.nativeElement.classList.add('active');
            }
          } 
          // AUTO-EXPAND: For top-level SmartDocs navigation lists
          else if (
            event.urlAfterRedirects.includes('dashboard') || 
            event.urlAfterRedirects.includes('doc-extract') || 
            event.urlAfterRedirects.includes('filer-summary') || 
            event.urlAfterRedirects.includes('knowledge-base')
          ) {
            this.document.body.classList.remove('sidebar-folded');
            if (this.sidebarToggler) {
              this.sidebarToggler.nativeElement.classList.remove('active');
            }
          }
        }
      }
    });

    this.commonService.cadStatusData.subscribe(res => {
      if (res) { /* reserved for future use */ }
    });
  }

  ngOnInit(): void {
    this.observeAmazonConnectButton();

    const desktopMedium = window.matchMedia('(min-width:992px) and (max-width: 1199px)');
    desktopMedium.addEventListener('change', () => { this.iconSidebar(desktopMedium); });
    this.iconSidebar(desktopMedium);
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  // ─── Amazon Connect observer ───────────────────────────────────────────────
  observeAmazonConnectButton() {
    const services = localStorage.getItem('services');
    const run = () => {
      const button = document.querySelector('button#amazon-connect-open-widget-button') as HTMLElement;
      if (button) {
        if (!services?.includes('ChatBot')) {
          button.style.setProperty('display', 'none', 'important');
        } else {
          button.style.removeProperty('display');
        }
        return true;
      }
      return false;
    };
    [800, 2000, 4500].forEach((ms) => setTimeout(run, ms));
  }

  toggleSidebar(e: Event) {
    this.sidebarToggler.nativeElement.classList.toggle('active');
    if (window.matchMedia('(min-width: 992px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-folded');
    } else if (window.matchMedia('(max-width: 991px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-open');
    }
  }

  get isSidebarFolded(): boolean {
    return this.document.body.classList.contains('sidebar-folded');
  }

  iconSidebar(mq: MediaQueryList) {
    if (mq.matches) {
      this.document.body.classList.add('sidebar-folded');
    } else {
      this.document.body.classList.remove('sidebar-folded');
    }
  }
}
